<template>
  <div>
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert_success" v-if="alert_show_day_off_week === true">เปลี่ยนวันหยุดประจำสัปดาห์ของร้านเรียบร้อย</v-alert>
      <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มวันหยุดพิเศษของร้านเรียบร้อย</v-alert>
      <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขวันหยุดพิเศษของร้านเรียบร้อย</v-alert>
      <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบวันหยุดพิเศษของร้านเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card class="pa-3 mb-2">
        <div class="d-flex align-center justify-space-between">
          <h2>วันหยุดประจำสัปดาห์ของร้าน</h2>
          <div>อัพเดทล่าสุด โดย {{ user_update_day_off_week }}</div>
        </div>

        <!--            <v-radio-group multiple class="mt-0" v-model="day_off_week" @change="editDayOffWeek" hide-details="auto">-->
        <!--                <div class="d-flex">-->
        <!--                    <div class="d-flex" v-for="(data, index) in day_off_week" :key="index">-->
        <!--                        <v-radio class="mb-0" :value="data.status_ckecked"></v-radio>-->
        <!--                        <div class="mr-1">{{ data.date_name }}</div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </v-radio-group>-->
        <div class="d-flex">
          <div v-for="(data, index) in day_off_week" :key="index">
            <div class="mr-2">
              <v-checkbox :label="data.date_name" v-model="data.status_ckecked" :value="data.status_ckecked" @change="editDayOffWeek(data.id, data.status_ckecked)"/>
            </div>
          </div>
        </div>
      </v-card>
      <v-card>
        <div class="px-3 pt-3 d-flex justify-space-between align-center">
          <h2>วันหยุดพิเศษของร้าน</h2>
          <div>
            <v-btn class="grad-primary-bg white--text" @click="openAddDayOff()" width="100%" height="65">
              เพิ่มวันหยุดพิเศษ
            </v-btn>
          </div>
        </div>
        <v-card-title>
          <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :search="search">
          <template v-slot:item="dataDetail">
            <tr>
              <td>{{dataDetail.item.number}}</td>
              <td>{{dataDetail.item.holiday_name}}</td>
              <td>{{dataDetail.item.start_date}}</td>
              <td>{{dataDetail.item.end_date}}</td>
              <td>{{dataDetail.item.user}}</td>
              <td>
                            <span class="cursor_day_off_restaurant_list" @click="openEditDayOff(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                            </span>
                <span class="cursor_day_off_restaurant_list" @click="openDeleteDayOff(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-delete</v-icon>
                            </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <!-- เพิ่ม -->
      <v-dialog v-model="open_add_day_off" persistent max-width="600px">
        <v-card>
          <v-form ref="form_add" @submit.prevent="addDayOff()">
            <v-card-title class="justify-space-between">
              <div>
                เพิ่มวันหยุดพิเศษ
              </div>
              <div class="cursor_day_off_restaurant_list" @click="open_add_day_off = false">
                <v-icon>mdi-close</v-icon>
              </div>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="ชื่อวันหยุด" v-model="holiday_name" :rules="[v => !!v || 'กรุณากรอกชื่อวันหยุด']" required outlined></v-text-field>
                    <div class="grid_day_off_restaurant_list">
                      <v-menu ref="menu_open_date_start" v-model="menu_open_date_start" :close-on-content-click="false" :return-value.sync="date_start" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_start_be" class="mr-1" label="วันที่เริ่มต้น (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่เริ่มต้น']" required outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date_start" :max="date_end" no-title scrollable locale="th" :events="dateStartEndBE('date_start')">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dateStartEnd('date_start')">
                            ตกลง
                          </v-btn>
                          <v-btn text color="primary" @click="menu_open_date_start = false">
                            ยกเลิก
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu ref="menu_open_date_end" v-model="menu_open_date_end" :close-on-content-click="false" :return-value.sync="date_end" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_end_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุด']" required outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date_end" class="ml-1" :min="date_start" no-title scrollable locale="th" :events="dateStartEndBE('date_end')">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dateStartEnd('date_end')">
                            ตกลง
                          </v-btn>
                          <v-btn text color="primary" @click="menu_open_date_end = false">
                            ยกเลิก
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>

                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn class="grad-primary-bg white--text" height="50" width="50%" type="submit">
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- แก้ไข -->
      <v-dialog v-model="open_edit_day_off" persistent max-width="600px">
        <div v-if="loading_page_detail === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <v-card v-if="loading_page_detail === false">
          <v-form ref="form_edit" @submit.prevent="editDayOff()">
            <v-card-title class="justify-space-between">
              <div>
                แก้ไขวันหยุดพิเศษ
              </div>
              <div class="cursor_day_off_restaurant_list" @click="open_edit_day_off = false">
                <v-icon>mdi-close</v-icon>
              </div>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field label="ชื่อวันหยุด" v-model="holiday_name" :rules="[v => !!v || 'กรุณากรอกชื่อวันหยุด']" required outlined></v-text-field>
                    <div class="grid_day_off_restaurant_list">
                      <v-menu ref="menu_open_date_start_edit" v-model="menu_open_date_start_edit" :close-on-content-click="false" :return-value.sync="date_start_edit" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_start_edit_be" class="mr-1" label="วันที่เริ่มต้น (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่เริ่มต้น']" required outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date_start_edit" :max="date_end_edit" no-title scrollable locale="th" :events="dateStartEndBE('date_start_edit')">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dateStartEndEdit('date_start_edit')">
                            ตกลง
                          </v-btn>
                          <v-btn text color="primary" @click="menu_open_date_start_edit = false">
                            ยกเลิก
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu ref="menu_open_date_end_edit" v-model="menu_open_date_end_edit" :close-on-content-click="false" :return-value.sync="date_end_edit" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="date_end_edit_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุด']" required outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date_end_edit" class="ml-1" :min="date_start_edit" no-title scrollable locale="th" :events="dateStartEndBE('date_end_edit')">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dateStartEndEdit('date_end_edit')">
                            ตกลง
                          </v-btn>
                          <v-btn text color="primary" @click="menu_open_date_end_edit = false">
                            ยกเลิก
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>

                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="open_confirm_delete" persistent max-width="600">
        <v-card>
          <v-card-title>
            ลบวันหยุดพิเศษของร้าน
          </v-card-title>

          <v-card-text>
            ท่านต้องการลบวันหยุดพิเศษของร้าน ใช่ หรือ ไม่ ?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" height="50" @click="deleteDayOff()">
              ตกลง
            </v-btn>
            <v-btn color="error" height="50" @click="open_confirm_delete = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import dayoffrestaurant from '@/api/team/teamsetting/dayoffrestaurant.js'
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: true,
      loading_page_detail: true,
      alert_show_day_off_week: false,
      alert_show_add: false,
      alert_show_edit: false,
      alert_show_delete: false,
      open_confirm_delete: false,
      day_off_week: [],
      obj_dayOff: [],
      user_update_day_off_week: '',
      open_add_day_off: false,
      open_edit_day_off: false,
      edit_id: null,
      holiday_name: null,
      menu_open_date_start: false,
      menu_open_date_end: false,
      menu_open_date_start_edit: false,
      menu_open_date_end_edit: false,
      date_start_be: '',
      date_start: '',
      date_end_be: '',
      date_end: '',
      date_start_edit_be: '',
      date_start_edit: '',
      date_end_edit_be: '',
      date_end_edit: '',
      search: '',
      headers: [{
        text: '#',
        align: 'start',
        value: 'number',
      },
        {
          text: 'วันหยุด',
          value: 'holiday_name'
        },
        {
          text: 'วันที่เริ่มต้น',
          align: 'date',
          value: 'start_date'
        },
        {
          text: 'วันที่สิ้นสุด',
          align: 'date',
          value: 'end_date'
        },
        {
          text: 'ผู้บันทึก',
          value: 'user'
        },
        {
          text: 'จัดการ',
          value: 'action'
        },
      ],
      data: []
    }
  },
  methods: {
    dateStartEndBE(type) {
      if (type == 'date_start') {
        if (this.date_start == '') {
          this.date_start_be = ''
        }
        if (this.date_start) {
          let date_arr = this.date_start.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.date_start_be = `${date_arr[2]}/${month}/${year}`
        }
      }
      if (type == 'date_end') {
        if (this.date_end == '') {
          this.date_end_be = ''
        }
        if (this.date_end) {
          let date_arr = this.date_end.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.date_end_be = `${date_arr[2]}/${month}/${year}`
        }
      }
      if (type == 'date_start_edit') {
        if (this.date_start_edit == '') {
          this.date_start_edit_be = ''
        }
        if (this.date_start_edit) {
          let date_arr = this.date_start_edit.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.date_start_edit_be = `${date_arr[2]}/${month}/${year}`
        }
      }
      if (type == 'date_end_edit') {
        if (this.date_end_edit == '') {
          this.date_end_edit_be = ''
        }
        if (this.date_end_edit) {
          let date_arr = this.date_end_edit.split('-')
          let year = parseInt(date_arr[0]) + 543
          let month = parseInt(date_arr[1]) - 1
          month = this.$store.state.monthList[month].name_short
          this.date_end_edit_be = `${date_arr[2]}/${month}/${year}`
        }
      }
    },
    async dateStartEnd(type) {
      if (type == 'date_start') {
        this.$refs.menu_open_date_start.save(this.date_start)
        let date_arr = this.date_start.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.date_start_be = `${date_arr[2]}/${month}/${year}`
        this.menu_open_date_start = false
      }
      if (type == 'date_end') {
        this.$refs.menu_open_date_end.save(this.date_end)
        let date_arr = this.date_end.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.date_end_be = `${date_arr[2]}/${month}/${year}`
        this.menu_open_date_end = false
      }

    },
    async dateStartEndEdit(type) {
      if (type == 'date_start_edit') {
        this.$refs.menu_open_date_start_edit.save(this.date_start_edit)
        let date_arr = this.date_start_edit.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.date_start_edit_be = `${date_arr[2]}/${month}/${year}`
        this.menu_open_date_start_edit = false
      }
      if (type == 'date_end_edit') {
        this.$refs.menu_open_date_end_edit.save(this.date_end_edit)
        let date_arr = this.date_end_edit.split('-')
        let year = parseInt(date_arr[0]) + 543
        let month = parseInt(date_arr[1]) - 1
        month = this.$store.state.monthList[month].name_short
        this.date_end_edit_be = `${date_arr[2]}/${month}/${year}`
        this.menu_open_date_end_edit = false
      }

    },
    async dayOffWeek() {
      dayoffrestaurant.dayOffWeek().then((response) => {
        if (response.data.successful === true) {
          this.day_off_week = response.data.week_holiday
          this.user_update_day_off_week = response.data.userManage
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async editDayOffWeek() {
      const id_week = this.day_off_week.map(data => data.id)
      const status = this.day_off_week.map((data) => {
        if (data.status_ckecked == true) {
          data.status_ckecked = 1
        }else {
          data.status_ckecked = 0
        }
        return data.status_ckecked
      })
      dayoffrestaurant.editDayOffWeek(id_week, status).then((response) => {
          if (response.data.successful === true) {
            this.dayOffWeek()
            this.alert_show_day_off_week = true
            setTimeout(() => this.alert_show_day_off_week = false, 5000)
          }
      }).catch((error) => {
          if (error.response.status === 401) {
              this.$store.commit('logOutSuccess')
              this.$router.push('/login')
          }
      })
    },
    async holidayList() {
      this.loading_page = true
      dayoffrestaurant.holidayList().then((response) => {
        if (response.data.successful === true) {
          this.data = response.data.holiday
          response.data.holiday.forEach((detail, index) => {
            this.data[index]['number'] = index + 1
          })
          this.loading_page = false
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async dayOffRestaurantList() {
      await this.dayOffWeek()
      await this.holidayList()
    },
    async openAddDayOff() {
      this.holiday_name = null
      this.date_start_be = ''
      this.date_start = ''
      this.date_end_be = ''
      this.date_end = ''
      this.open_add_day_off = true
    },
    async addDayOff() {
      if (this.$refs.form_add.validate()) {
        this.open_add_day_off = false
        this.loading_page = true
        const data = {
          holiday_name: this.holiday_name,
          start_date: this.date_start,
          end_date: this.date_end,
        }
        dayoffrestaurant.addHoliday(data).then((response) => {
          if (response.data.successful === true) {
            this.holiday_name = null
            this.date_start_be = ''
            this.date_start = ''
            this.date_end_be = ''
            this.date_end = ''
            this.dayOffRestaurantList()
            this.alert_show_add = true
            setTimeout(() => this.alert_show_add = false, 5000)
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
      }
    },
    async openEditDayOff(id) {
      this.loading_page_detail = true
      this.open_edit_day_off = true
      this.edit_id = null
      this.holiday_name = null
      this.date_start_edit_be = ''
      this.date_start_edit = ''
      this.date_end_edit_be = ''
      this.date_end_edit = ''
      dayoffrestaurant.detailHoliday(id).then((response) => {
        if (response.data.successful === true) {
          this.edit_id = response.data.holiday.id
          this.holiday_name = response.data.holiday.holiday_name
          this.date_start_edit = response.data.holiday.start_date
          this.date_end_edit = response.data.holiday.end_date
          this.loading_page_detail = false
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async editDayOff() {
      if (this.$refs.form_edit.validate()) {
        this.open_edit_day_off = false
        this.loading_page = true
        const data = {
          holiday_name: this.holiday_name,
          start_date: this.date_start_edit,
          end_date: this.date_end_edit,
        }
        dayoffrestaurant.editHoliday(this.edit_id, data).then((response) => {
          if (response.data.successful === true) {
            this.edit_id = null
            this.holiday_name = null
            this.date_start_edit_be = ''
            this.date_start_edit = ''
            this.date_end_edit_be = ''
            this.date_end_edit = ''
            this.dayOffRestaurantList()
            this.alert_show_edit = true
            setTimeout(() => this.alert_show_edit = false, 5000)
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
      }
    },
    async openDeleteDayOff(id) {
      this.edit_id = id
      this.open_confirm_delete = true
    },
    async deleteDayOff() {
      this.open_confirm_delete = false
      this.loading_page = true
      dayoffrestaurant.deleteHoliday(this.edit_id).then((response) => {
        if (response.data.successful === true) {
          this.edit_id = null
          this.holiday_name = null
          this.date_start_edit_be = ''
          this.date_start_edit = ''
          this.date_end_edit_be = ''
          this.date_end_edit = ''
          this.dayOffRestaurantList()
          this.alert_show_delete = true
          setTimeout(() => this.alert_show_delete = false, 5000)
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    }
  },
  mounted() {
    this.dayOffRestaurantList()
  }
}
</script>

<style scoped>
.grid_day_off_restaurant_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.cursor_day_off_restaurant_list {
  cursor: pointer;
}
</style>
